module.exports = __webpack_public_path__ + "img/组 137@2x.d78001d2.png";